<template>
	<div class="file">
		<form @submit.prevent="onSubmit" enctype="multipart/form-data">
			<div id="add-book-grid">
				<label id="cover-label">Upload Cover</label>
				<input
					id="cover-input"
					type="file"
					ref="file"
					v-bind:style="{ backgroundImage: 'url(' + getCover + ')' }"
					@change="onSelect"
				/>
				<div></div>
				<div>
					<label>Title</label>
					<input type="text" v-model="bookname"/>
				</div>
				<div>
					<label>Author</label>
					<input type="text" v-model="searchTerm"/>
					<button v-on:click=authorSearch()>Search Author</button>
				</div>	
				<div v-for="author in authors" :key=author.author_id>
					<label>{{author.name}}</label>
					<input type="checkbox" :value="author"/>
				</div>
				<div>
					<label>Year</label>
					<input id="year-label" type="number" v-model="year"/>
				</div>
				<div class="full-width-input">
					<label>description</label>
					<textarea v-model="description" placeholder="A blurb  about the book (maximum 1000 characters)." maxlength="1000"></textarea>
				</div>
				<div class="full-width-input content-buttons center-container">
					<button>Add Book</button>
					<div class="message">
						<h5>{{message}}</h5>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>

	export default 
	{
		data() 
		{
			return {
				searchTerm: "",
				file: "",
				message: "",
				bookname: "",
				author: "",
				description: "",
				year: "",
				authors: []
			}
		},
		computed:
		{
			getCover: function ()
			{
				return "image";
			}
		},
		methods: 
		{
			onSelect()
			{
				const file = this.$refs.file.files[0];
				this.file = file;
			},
			async onSubmit()
			{
				// do with fetch //
				// const formData = new FormData();
				// formData.append('file',this.file);
				// formData.append('bookname', this.bookname);
				// formData.append('author', this.author);
				// formData.append('description', this.description);
				// formData.append('year', this.year)
				// try 
				// {
				//     await axios.post('http://books.goodbyte.ca:8081/api/book/add', formData)
				//     this.message = "Succsess"
				// } 
				// catch(err) 
				// {
				//     console.log(err)
				//     this.message = "Error"
				// }
			},
			authorSearch()
			{
				fetch('https://api.bookplate.co/search/authors/test/' + this.searchTerm,
				{
					credentials: 'include'
				})
				.then(function(response)
				{
					if(response.status != 200)
					{
						throw response.status;
					}

					return response.json();
				})
				.then(json => this.authors = json)

			}
		}
	}
</script>